module.exports = __webpack_public_path__ + "static/media/ad0.572a679e.png";